export const contextFunctionInit = (): void => {
    throw new Error("This function should have been initialized.");
};

export const contextAsyncFunctionInit = (): Promise<void> => {
    throw new Error("This function should have been initialized.");
};
